// Gtag tracking utility functions for Google Ads conversions
export const trackPhoneConversion = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18050305527/pu1BCL2opJUcEPebh59D',
      'value': 1.0,
      'currency': 'EUR'
    });
  }
};